import { helper } from '@ember/component/helper';

function lfOr(params /*, hash*/) {
  return params.reduce((a, b) => a || b, false);
}
var lfOr$1 = helper(lfOr);

export { lfOr$1 as default, lfOr };
//# sourceMappingURL=lf-or.js.map
